import { slideUp, slideDown } from 'es6-slide-up-down';
import AOS from 'aos';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/artdirect/ls.artdirect';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import Accordion from './lib/accordion.ts';
import vacancies from './vacancies';
import embeddedVideo from './embeddedVideo';
import homeSlider from './homeSlider';
import fixedElements from './toggleFIxedElements';
import awards from './awards';
import modals from './modal';
import searchBarFilter from './searchBarFilter';
import menu from './menu';
import share from './share';
import tabs from './tabs';
import videoModals from './videoModals';
import filters from './filters';
import typewriter from './typewriter';
import { debounce } from './helpers';
import form from './form';

// lazySizes.cfg.autoArtDirect = true;
lazySizes.cfg.customMedia = {
    '--sm': '(max-width: 576px)',
    '--md': '(max-width: 768px)',
    '--lg': '(max-width: 992px)',
    '--xl': '(max-width: 1200px)',
};

function slideToggle(target, duration = 500) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    }

    return slideUp(target, duration);
}

function siteMapInit() {
    const siteMapItems = document.querySelectorAll('.sitemap__link');
    if (!siteMapItems.length) return;

    const itemsArr = [...siteMapItems];
    if (itemsArr.length > 0) {
        itemsArr.forEach((item) => {
            const target = item.dataset.linkTarget || '_self';
            item.addEventListener('click', () => {
                window.open(item.dataset.linkUrl, target);
            });
        });
    }
}

function modalThankYouForm() {
    let pathName = window.location.pathname;
    let modalPromoForm = document.getElementById('popup-promo-form-modal');
    if(pathName == '/thank-you' || pathName == 'thank-you') {
        try {
            modalPromoForm.remove();
        }
        catch (err) {
            /* console.log(err.message)*/
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    siteMapInit();

    // Webinar Updates Popup
    const webinarUpdatesPopupBtn = document.querySelector('.webinar-updates-btn');
    const webinarUpdatesPopup = document.querySelector('.webinar-updates-popup');
    const webinarPopupCloseBtn = document.querySelector('.webinar-updates-popup__close-btn');
    var closepopupTimer = webinarUpdatesPopup && webinarUpdatesPopup.dataset && webinarUpdatesPopup.dataset.closepopupTimer ? parseInt(webinarUpdatesPopup.dataset.closepopupTimer) : 30000;
    if (webinarUpdatesPopup && webinarUpdatesPopup.dataset && webinarUpdatesPopup.dataset.closepopupTimer) {
        webinarUpdatesPopupBtn.addEventListener('click', () => {
            webinarUpdatesPopup.classList.add('webinar-updates-popup__open');
            webinarUpdatesPopupBtn.classList.add('webinar-updates-btn__hide');
        });
        webinarPopupCloseBtn.addEventListener('click', () => {
            closeWebinarPopup();
        });
        function closeWebinarPopup() {
            webinarUpdatesPopup.classList.remove('webinar-updates-popup__open');
            webinarUpdatesPopupBtn.classList.remove('webinar-updates-btn__hide');
        }
        function closeWebinarPopupTimeout(time) {
            setTimeout(() => {
                closeWebinarPopup();
            }, time || 30000);
        }
        if (closepopupTimer) {
            const parsedTime = closepopupTimer * 1000;
            closeWebinarPopupTimeout(parsedTime)
        } else {
            closeWebinarPopupTimeout();
        }
    }
    
    modalThankYouForm();
    const triggers = document.querySelectorAll('.js-accordion-trigger');

    vacancies.init();
    embeddedVideo.init();
    homeSlider.init();
    fixedElements.init();
    filters.init();
    awards.init();
    modals.init();
    searchBarFilter.init();
    menu.init();
    share.init();
    tabs.init();
    videoModals.init();
    typewriter.init();
    form.init();

    // Add class to <body> during resizes
    let resizeTimer;
    let resizing;
    window.addEventListener(
        'resize',
        () => {
            if (!resizing) document.body.classList.add('resizing');

            resizing = true;

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                document.body.classList.remove('resizing');
                resizing = false;
            }, 150);
        },
        { passive: true }
    );

    function sliderToggle(e) {
        const element = e.currentTarget;

        if (window.innerWidth > 600) return;

        const collapse = element.parentElement.querySelector(
            '.js-accordion-collapse'
        );

        if (collapse) {
            slideToggle(collapse, {
                duration: 500,
            });
        }
    }

    triggers.forEach((element) =>
        element.addEventListener('click', sliderToggle)
    );

    function footerSocialMove(mediaQuery) {
        const instaEl = document.querySelector('#colInsta');
        if (mediaQuery.matches && instaEl) {
            instaEl.appendChild(document.querySelector('#colSocial'));
            document.getElementById('colSocial').style.paddingTop = '20px';
        } else {
            document
                .querySelector('.col-followUs')
                .appendChild(document.querySelector('#colSocial'));
            document.getElementById('colSocial').style.paddingTop = '0px';
        }
    }

    const mediaQuery = window.matchMedia('(max-width: 576px)');
    footerSocialMove(mediaQuery);
    mediaQuery.addListener(footerSocialMove);

    const accordions = document.querySelectorAll('.js-accordion');
    accordions.forEach((accordion) => new Accordion(accordion));

    // Filter Search page
    function filterSelection(filter) {
        const sections = document.querySelectorAll('.search-filter');
        if (sections != null) {
            sections.forEach((section) => {
                section.classList.remove('search-filter--hidden');

                if (filter && !section.classList.contains(filter))
                    section.classList.add('search-filter--hidden');
            });
        }
    }

    const filterContainer = document.getElementById('filter');

    if (filterContainer != null) {
        filterContainer.querySelectorAll('.btn-filter').forEach((button) => {
            button.addEventListener('click', () => {
                const current = document.querySelector('.active');

                current.classList.remove('active');
                button.classList.add('active');

                const section = button.dataset.target;
                filterSelection(section);
            });
        });
    }

    const scrollToTopButton = document.querySelector('.js-back-to-top');
    if (scrollToTopButton) {
        const watchScroll = () => {
            const visibleOffset = 500;
            const visibleClass = 'back-to-top--visible';
            const visible = scrollToTopButton.classList.contains(visibleClass);

            if (!visible && window.scrollY > visibleOffset) {
                scrollToTopButton.classList.add(visibleClass);
            } else if (visible && window.scrollY <= visibleOffset) {
                scrollToTopButton.classList.remove(visibleClass);
            }
        };

        window.addEventListener('scroll', watchScroll, { passive: true });
        scrollToTopButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.scroll(0, 0);
        });
    }

    const scrollDownButton = document.querySelector('.js-scroll-to-main');
    if (scrollDownButton) {
        scrollDownButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.scroll(0, 750);
        });
    }

    // Accordion programme overview card
    const elements = document.querySelectorAll('.js-toggle-card');

    elements.forEach((element) => {
        const content = element.querySelector('.programme-overview-card');
        const button = element.querySelector(
            '.programme-overview-card__footer--accordion'
        );

        if (button) {
            button.addEventListener(
                'click',
                () => {
                    content.classList.toggle('programme-overview-card--close');
                },
                false
            );
        }
    });

    const banner = document.querySelector('.js-fixed-banner');
    if (banner) {
        const adjustMargin = () => {
            const { height: bannerHeight } = banner.getBoundingClientRect();
            document.body.style.marginTop = `${bannerHeight}px`;
        };
        window.addEventListener('resize', debounce(adjustMargin, 80, false));
        adjustMargin();
    }

    // Scroll to the #target-element on load
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            const position =
                window.scrollY + target.getBoundingClientRect().top - 70;
            if ('scrollBehavior' in document.documentElement.style)
                window.scroll({ top: position, behavior: 'auto' });
            else window.scroll(0, position);
        }
    }


    AOS.init({
        disable: 'mobile',
        once: 'true',
        anchorPlacement: 'center-center',
    });
    // Events List
    eventsList();


});


const eventsList = () => {
    const eventsContainer = [...document.getElementsByClassName('events-list')];
    if (eventsContainer.length === 0) return;

    eventsContainer.forEach((eventsContainer) => {
        const eventItems = eventsContainer.querySelectorAll('.eventItem');
        const eventItemsList = [...eventItems];
        const eventsListMoreBtn = eventsContainer.querySelector('.events-list-more-btn');
        const eventFilter = eventsContainer.querySelector('.event-filter');
        const displayEventsCountElements = document.querySelector('.display-events-count');
        let displayEventsCount = parseInt(displayEventsCountElements.value ? displayEventsCountElements.value : 0);

        if (eventsListMoreBtn != null) {
            eventsListMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                console.log("event filter", eventFilter.value);
                displayEventsCountElements.value = displayEventsCount += 9;
                let displayedItems = 0;
                let filteredEvents = eventItemsList.filter((event) => ((eventFilter.value === 'all' && true) || event.dataset.category === eventFilter.value));
                console.log(filteredEvents, 'filteredEvents');
                eventItemsList.forEach(event => {
                    const category = event.dataset.category;
                    if (eventFilter.value == 'all') {
                        let eventItemCount = event.dataset.eventItemCount;
                        event.style.display = eventItemCount > displayEventsCount ? 'none' : '';
                    }
                    else if (category === eventFilter.value) {
                        event.style.display = displayedItems > displayEventsCount ? 'none' : '';
                        displayedItems++;
                    }
                    else {
                        event.style.display = 'none';
                    }
                });
                if (displayEventsCount >= (filteredEvents.length)) {
                    // Hide more button when all events are shown
                    eventsListMoreBtn.style.display = 'none';
                }
            });
        }
        if (eventFilter != null) {
            eventFilter.addEventListener('change', function (e) {
                eventsListMoreBtn.style.display = 'block';
                let filterValue = this.value;
                console.log("filter value", filterValue);
                let displayedItems = 0;
                let filteredEvents = eventItemsList.filter((event) => ((eventFilter.value === 'all' && true) || event.dataset.category === eventFilter.value));
                eventItemsList.forEach((item) => {
                    if (displayEventsCountElements != null && displayedItems < displayEventsCount) {
                        const category = item.dataset.category;
                        if (filterValue === 'all') {
                            item.style.display = '';
                            displayedItems++;
                        }
                        else if (category === filterValue) {
                            item.style.display = '';
                            displayedItems++;
                        }
                        else {
                            item.style.display = 'none';
                        }
                    }
                });
                displayEventsCountElements.value = 3;
                if (displayEventsCount >= (filteredEvents.length)) {
                    // Hide more button when all events are shown
                    eventsListMoreBtn.style.display = 'none';
                }
            });

        }
       
    });
};